<template lang="pug">
.card-list-container
  .list(
    v-for="(item,index) in packages"
  )
    rideCardItem(
       v-if="item && typeof item === 'object' && Object.keys(item).length > 0"
    :packageData="item" @buyCard="buyCard")
</template>
<script>
import { getTWCards } from '@/api/card';
import { getSystemCode, getVersion } from '@/utils/systemCode';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import rideCardItem from './ride-card-info';
import { getTokenAndLocation, getTWCardPlatform, tryCatch } from '../../../../../utils';
import { ParamsUtil } from '../../../../../utils/params';

export default {
  inject: ['latestTabCode'],
  components: {
    rideCardItem,
  },
  props: {
    moduleData: {
      type: Object,
      default: () => { },
    },
    tryingCardData: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      env: process.env,
      packages: [],
      subpackages: [],
      adSource: null,
    };
  },
  computed: {
    tabCode() {
      return this.latestTabCode();
    },
  },
  watch: {
    moduleData: {
      deep: true,
      immediate: true,
      handler() {
        this.getData();
      },
    },
  },
  mounted() {
    UBT.moduleExpose({
      pageId: 'platform_openedcard_page',
      categoryId: 'platform',
      moduleId: 'platform_sale_card',
      contentId: 'platform_sale_card',
      exposureTimes: 1,
      businessInfo: {
      },
    });
    if (this.moduleData.rideMoneyData) {
      this.$emit('rideMoneyData', this.moduleData.rideMoneyData);
    }
  },
  methods: {
    getData() {
      const { adSource } = ParamsUtil.getParams(window.location.href);
      this.adSource = adSource;
      // 确保 packages 始终是数组，即使是空数组
      this.packages = Array.isArray(this.moduleData.packages) ? this.moduleData.packages : [];
      if (this.packages && this.packages.length > 0) {
        this.packages.forEach((element) => {
          // eslint-disable-next-line no-param-reassign
          element.channelCode = this.moduleData.channelCode;
        });
      }

      if (this.moduleData.tryingCardData) {
        this.subpackages = this.moduleData.tryingCardData.packages;
        if (this.subpackages && this.subpackages.length > 0) {
          this.subpackages.forEach((element) => {
            // eslint-disable-next-line no-param-reassign
            element.channelCode = this.tryingCardData.channelCode;
          });
          // 确保 this.packages 是数组后再合并
          this.packages = Array.isArray(this.packages) ? this.packages : [];
          this.packages = this.subpackages.concat(this.packages);
        }
      }
    },
    buyCard(val) {
      this.$emit('buyCard', val);
    },
    async getValue() {
      const { token, cityCode, adCode } = await getTokenAndLocation();
      const res = await getTWCards({
        token,
        adCode,
        cityCode,
        businessId: this.tabCode === 'ride' ? 1 : 2, // 单车
        channelCodes: [this.moduleData.channelCode],
        platform: getTWCardPlatform(),
        version: await getVersion(),
        systemCode: getSystemCode(),
        adSource: this.adSource,
      }).then((v) => tryCatch(() => v.data.packageGroups[0]), null)
        .catch(() => null);
      if (res) {
        const { packages } = res;
        if (packages) {
          this.packages = packages;
          this.packages.forEach((element) => {
            // eslint-disable-next-line no-param-reassign
            element.channelCode = this.moduleData.channelCode;
          });
        }
      }
    },
    async getsubValue() {
      const { token, cityCode, adCode } = await getTokenAndLocation();
      const res = await getTWCards({
        token,
        adCode,
        cityCode,
        businessId: this.tabCode === 'ride' ? 0 : 1, //
        channelCodes: [this.moduleData.tryingCardData.channelCode],
        platform: getTWCardPlatform(),
        version: await getVersion(),
        systemCode: getSystemCode(),
        adSource: this.adSource,
      }).then((v) => tryCatch(() => v.data.packageGroups[0]), null)
        .catch(() => null);
      if (res) {
        const { packages } = res;
        this.subpackages = packages;
        if (packages) {
          this.subpackages.forEach((element) => {
            // eslint-disable-next-line no-param-reassign
            // element.isopen = true;
            // eslint-disable-next-line no-param-reassign
            element.channelCode = this.moduleData.tryingCardData.channelCode;
          });
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.card-list-container {
  margin: 0.08rem 0.12rem 0.12rem 0.12rem;
}
</style>
